import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import dynamic from 'next/dynamic';

const StyleGuideButtonsComposable = dynamic(
  () => import('composables/StyleGuide/Buttons/StyleGuideButtons'),
  {
    ssr: true,
    loading: () => <div className="h-96 w-full animate-pulse bg-gray-100" />,
  }
);

export const StyleGuide = () => {
  return (
    <div className="container flex flex-row justify-center px-24">
      <StyleGuideButtonsComposable />
    </div>
  );
};

export default withDatasourceCheck()(StyleGuide);
